import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as XLSX from 'xlsx';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { useNavigate, useLocation } from 'react-router-dom';
import PdfPreview from '../../../../Common/PDFPreview';
import { RingLoader } from 'react-spinners';
import { Typography } from '@mui/material';
import { FormaDateBalanceSheet } from "../../../../Common/FormatFunctions/FormatDate"
import { formatReadableAmount } from "../../../../Common/FormatFunctions/FormatAmount";
import PrintButton from '../../../../Common/Buttons/PrintPDF';

const apikey = process.env.REACT_APP_API;

const PartyWiseDo = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const searchParams = new URLSearchParams(location.search);
    const fromDate = searchParams.get('fromDate');
    const toDate = searchParams.get('toDate');
    const acCode = searchParams.get('acCode');
    const companyCode = sessionStorage.getItem('Company_Code');
    const Year_Code = sessionStorage.getItem('Year_Code');
    const Company_Name = sessionStorage.getItem('Company_Name');
    const Company_GSTNO = sessionStorage.getItem('Company_GSTNO')

    const [reportData, setReportData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [pdfPreview, setPdfPreview] = useState(null);

    const API_URL = `${apikey}/PartyWiseDO`;

    useEffect(() => {
        const fetchReportData = async () => {
            setLoading(true);
            setError('');
            try {
                const response = await axios.get(API_URL, {
                    params: {
                        fromDT: fromDate,
                        toDT: toDate,
                        Company_Code: companyCode,
                        Year_Code: Year_Code,
                        acCode: acCode
                    },
                });

                // Ensure response data is an array
                const data = Array.isArray(response.data) ? response.data : [];
                setReportData(data);

            } catch (error) {
                console.error('Error fetching report:', error);
                setError('Error fetching report');
            } finally {
                setLoading(false);
            }
        };

        if (fromDate && toDate) {
            fetchReportData();
        }
    }, [fromDate, toDate, companyCode, Year_Code, acCode]);

    const handlePrint = () => {
        const printContent = document.getElementById('reportTable').outerHTML;
        const win = window.open('', '', 'height=700,width=900');
        win.document.write(`
            <html>
                <head>
                    <title>Print Report</title>
                    <style>
                        body { font-family: Arial; margin: 20px; }
                        .company-name { text-align: center; font-size: 24px; font-weight: bold; margin-bottom: 20px; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
                        th { background-color: #f2f2f2; font-weight: bold; }
                        tr:nth-child(even) { background-color: #f9f9f9; }
                        .total-row { background-color: #e0f7fa; font-weight: bold; }
                    </style>
                </head>
                <body>
                    <div class="company-name">${Company_Name}</div>
                    ${printContent}
                </body>
            </html>
        `);
        win.document.close();
        win.print();
    };

    const generatePdf = () => {
        const doc = new jsPDF();
        const pageWidth = doc.internal.pageSize.getWidth();
        const textWidth = doc.getTextWidth(Company_Name);
        const xPosition = (pageWidth - textWidth) / 2;

        doc.text(Company_Name, xPosition, 10);
        doc.autoTable({ html: '#reportTable' });

        const pdfBlob = doc.output('blob');
        const url = URL.createObjectURL(pdfBlob);
        setPdfPreview(url);
    };

    const handleExportToExcel = () => {
        const wb = XLSX.utils.book_new();
        const wsData = [];

        wsData.push([Company_Name]);
        wsData.push([]);
        wsData.push(['Party Wise DO Report']);
        wsData.push([]);
        wsData.push(['DoNo', 'Date', 'Mill', 'Grade', 'Quantal', 'M Rate', 'Lorry No', 'SRate', 'Dispatch To', 'SB No']);

        Object.entries(groupedReportData).forEach(([key, { items }]) => {
            wsData.push([key]);

            let totalQty = 0;

            items.forEach(item => {
                const qty = parseFloat(item.DI_Qty) || 0;
                totalQty += qty;

                wsData.push([
                    item.detail_id,
                    item.DI_Date,
                    item.millshortname,
                    item.grade,
                    qty,
                    item.mill_rate,
                    item.truck_no,
                    item.sale_rate,
                    item.getpassname,
                    item.SB_No
                ]);
            });

            wsData.push(['', '', '', 'Total', totalQty.toFixed(2), '', '', '', '', '']);
            wsData.push([]);
        });

        const ws = XLSX.utils.aoa_to_sheet(wsData);
        XLSX.utils.book_append_sheet(wb, ws, 'PartyWiseDO');
        XLSX.writeFile(wb, 'PartyWiseDO.xlsx');
    };

    const handleVoucherClick = (doc_no) => {
        const url = `${window.location.origin}/delivery-order`;
        const params = new URLSearchParams({ navigatedRecord: doc_no });
        window.open(`${url}?${params.toString()}`, '_blank');
    };

    const handleSBNoClick = (doc_no) => {
        const url = `${window.location.origin}/sale-bill`;
        const params = new URLSearchParams({ navigatedRecord: doc_no });
        window.open(`${url}?${params.toString()}`, '_blank');
    };

    const groupReportData = (data) => {
        const grouped = {};

        if (!Array.isArray(data)) {
            console.error("Expected array in groupReportData, received:", data);
            return grouped;
        }

        data.forEach(item => {
            const key = `${item.voucher_by}-${item.voucherbyname}`;
            if (!grouped[key]) {
                grouped[key] = { items: [] };
            }
            grouped[key].items.push(item);
        });

        return grouped;
    };

    const groupedReportData = groupReportData(reportData);

    return (
        <div style={{ marginTop: '-80px' }}>
            {/* <Typography variant="h6" style={{ textAlign: 'center', fontSize: "24px", fontWeight: "bold" }}>{Company_Name}</Typography>
            <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px", textDecoration: 'underline', fontWeight: "550" }}>GSTN : {Company_GSTNO}</Typography> */}

            <div className="d-flex justify-content-between align-items-center ">
                <div style={{ flex: 1, textAlign: 'center', marginLeft: "280px" }}>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "20px", fontWeight: "bold" }}>Party Wise DO</Typography>
                    <Typography variant="h6" style={{ textAlign: 'center', fontSize: "16px" }}>{FormaDateBalanceSheet(fromDate)} to {FormaDateBalanceSheet(toDate)}</Typography>
                </div>

                <div className="d-flex justify-content-end gap-2">
                    <PrintButton disabledFeild={""} fetchData={handlePrint} />
                    <button className="btn btn-success me-2" onClick={handleExportToExcel}>Export to Excel</button>
                    <button className="btn btn-secondary" onClick={generatePdf}>PDF</button>
                </div>
            </div>


            {loading ? (
                <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
                    <RingLoader />
                </div>
            ) : error ? (
                <div className="alert alert-danger">{error}</div>
            ) : (
                <div style={{ maxHeight: "800px", overflowY: "auto" }}>
                    <table className="table table-striped table-bordered mt-4" id="reportTable" style={{ marginBottom: "60px", width: "100%" }}>
                        <thead className="table-light" style={{ position: "sticky", top: 0, backgroundColor: "#fff", zIndex: 1, whiteSpace: "nowrap" }}>
                            <tr>
                                <th>Do No.</th>
                                <th>Date</th>
                                <th>Mill Name</th>
                                <th>Grade</th>
                                <th>Quintal</th>
                                <th>Mill Rate</th>
                                <th>Sale Rate</th>
                                <th>Lorry No</th>
                                <th>Dispatch To</th>
                                <th>Sale Bill No.</th>
                            </tr>
                        </thead>
                        <tbody>
                            {Object.entries(groupedReportData).map(([key, { items }]) => {
                                const totalQty = items.reduce((sum, item) => sum + parseFloat(item.DI_Qty || 0), 0);

                                return (
                                    <React.Fragment key={key}>
                                        <tr>
                                            <td colSpan={10} align="left" className="table-primary" style={{ color: 'blue', fontWeight: 'bold' }}>{key}</td>
                                        </tr>
                                        {items.map((item, index) => (
                                            <tr key={index}>
                                                <td
                                                    align="center"
                                                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                                    onClick={() => handleVoucherClick(item.detail_id)}
                                                >
                                                    {item.detail_id}
                                                </td>
                                                <td align="center" style={{ fontWeight: 'bold' }}>{item.DI_Date}</td>
                                                <td align="left">{item.millshortname}</td>
                                                <td align="left">{item.grade}</td>
                                                <td align="right">{item.DI_Qty}</td>
                                                <td align="right" style={{ fontWeight: 'bold' }}>{formatReadableAmount(item.mill_rate)}</td>
                                                <td align="right">{formatReadableAmount(item.sale_rate)}</td>
                                                <td align="center">{item.truck_no}</td>
                                                <td align="left">{item.getpassname}</td>
                                                <td
                                                    align="center"
                                                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                                                    onClick={() => handleSBNoClick(item.SB_No)}
                                                >
                                                    {item.SB_No}
                                                </td>
                                            </tr>
                                        ))}
                                        <tr style={{ fontWeight: 'bold', backgroundColor: '#f0f8ff' }}>
                                            <td colSpan={4} align="right">Total</td>
                                            <td>{totalQty.toFixed(2)}</td>
                                            <td colSpan={5}></td>
                                        </tr>
                                    </React.Fragment>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {pdfPreview && (
                <div className="centered-container">
                    <PdfPreview pdfData={pdfPreview} apiData={reportData} label={'NewDispatchRegister'} />
                </div>
            )}
        </div>
    );
};

export default PartyWiseDo;
